
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 13","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.073 9.921l4.495-4.5a.498.498 0 000-.705l-1.5-1.5a.495.495 0 00-.355-.145.516.516 0 00-.355.145L5.713 5.861 3.068 3.216a.5.5 0 00-.71.005L.863 4.726a.51.51 0 00-.145.35c0 .125.05.255.145.355l4.495 4.495c.195.195.51.195.705 0l.01-.005z"}})])
          )
        }
      }
    